var normalizeComponent = require("!../../../node_modules/.pnpm/vue-loader@13.7.3_babel-core@6.26.3_css-loader@3.6.0_webpack@3.12.0__handlebars@4.7.8_l_afaedb81a46d9d75a968e67803c82c7b/node_modules/vue-loader/lib/component-normalizer")
/* script */
export * from "!!babel-loader!../../../node_modules/.pnpm/vue-loader@13.7.3_babel-core@6.26.3_css-loader@3.6.0_webpack@3.12.0__handlebars@4.7.8_l_afaedb81a46d9d75a968e67803c82c7b/node_modules/vue-loader/lib/selector?type=script&index=0!./jichuxinxi.vue"
import __vue_script__ from "!!babel-loader!../../../node_modules/.pnpm/vue-loader@13.7.3_babel-core@6.26.3_css-loader@3.6.0_webpack@3.12.0__handlebars@4.7.8_l_afaedb81a46d9d75a968e67803c82c7b/node_modules/vue-loader/lib/selector?type=script&index=0!./jichuxinxi.vue"
/* template */
import __vue_template__ from "!!../../../node_modules/.pnpm/vue-loader@13.7.3_babel-core@6.26.3_css-loader@3.6.0_webpack@3.12.0__handlebars@4.7.8_l_afaedb81a46d9d75a968e67803c82c7b/node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-46e10f26\",\"hasScoped\":false,\"transformToRequire\":{\"video\":[\"src\",\"poster\"],\"source\":\"src\",\"img\":\"src\",\"image\":\"xlink:href\"},\"buble\":{\"transforms\":{}}}!../../../node_modules/.pnpm/vue-loader@13.7.3_babel-core@6.26.3_css-loader@3.6.0_webpack@3.12.0__handlebars@4.7.8_l_afaedb81a46d9d75a968e67803c82c7b/node_modules/vue-loader/lib/selector?type=template&index=0!./jichuxinxi.vue"
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

export default Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/pages/prints/jichuxinxi.vue
// module id = null
// module chunks = 